import { Box, Modal } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC } from 'react';

import { Colors } from '@/assets';

interface IProps {
    open: boolean;
    onClose?: () => void;
    style?: SxProps;
}

export const AppModal: FC<IProps> = ({ open, onClose, children, style }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute' as const,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    overflow: 'auto',
                    bgcolor: 'background.paper',
                    '&:focus-visible': { outline: 'none' },
                    border: '1px solid',
                    borderColor: Colors.linkWater,
                    borderRadius: '8px',
                    ...style
                }}
            >
                {children}
            </Box>
        </Modal>
    );
};
